import api from '@/services/api'

export default {
  getCoupons() {
    return api.get('/coupons');
  },
  createCoupon(data) {
    return api.post('/coupons', data)
  },
  updateCoupon(data) {
    return api.put(`/coupons/${data._id}`, data)
  },
  removeCoupon(data) {
    return api.delete(`/coupons/${data._id}`)
  },
  activateCoupon(id) {
    return api.put(`/coupons/${id}`, { active: true })
  },
  deactivateCoupon(id) {
    return api.put(`/coupons/${id}`, { active: false })
  },
}